import { validDate } from '@shared/helpers/date-time-utils';

export abstract class StorageBaseService {
    protected abstract readonly storage: Storage;

    /**
     * Gets a saved item from SessionStorage
     * @param key
     * @param options
     */
    getItem<R>(key: string, options?: { decode: boolean }): R | undefined {
        let item = this.storage.getItem(key);
        try {
            if (options?.decode) {
                item = atob(item);
            }
            return JSON.parse(item, (k, v) => this.jsonReviver(k, v)) as R;
        } catch (e) {
            return undefined;
        }
    }

    /**
     * Saves an item in SessionStorage. Type param is essential to avoid unwanted behaviours in the caching process
     * @param key
     * @param value
     * @param options
     */
    saveItem<T>(key: string, value: T, options?: { encode: boolean }): void {
        let stringToSave = JSON.stringify(value, (k, v) => this.jsonReplacer(k, v));
        if (options?.encode) {
            stringToSave = btoa(stringToSave);
        }
        this.storage.setItem(key, stringToSave);
    }

    hasItem(key: string, storage = sessionStorage): boolean {
        return key in storage;
    }

    protected jsonReviver<T>(key: string, value: T): unknown {
        const isValidDate = typeof value === 'string' && validDate(value);
        return isValidDate ? new Date(value as string) : value;
    }

    protected jsonReplacer<T>(key: string, value: T): unknown {
        return value instanceof Map ? Array.from(value) : value;
    }
}
